'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BasePickupLocator = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(BasePickupLocator, _React$Component);

  function BasePickupLocator(props, context) {
    (0, _classCallCheck3.default)(this, BasePickupLocator);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BasePickupLocator.__proto__ || (0, _getPrototypeOf2.default)(BasePickupLocator)).call(this, props, context));

    _this.state = { showMore: false };
    return _this;
  }

  (0, _createClass3.default)(BasePickupLocator, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window.addEventListener('popstate', this.handleNavigation);
      window.closePickupLocator = this.props.close;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onOpen();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('popstate', this.handleNavigation);
      window.closePickupLocator = undefined;
    }
  }, {
    key: 'getLocations',
    value: function getLocations() {
      var locations = this.props.pickupLocations;

      if (!this.state.showMore) {
        locations = locations.slice(0, BasePickupLocator.maxNUmberBeforeShowMore);
      }

      return locations;
    }

    // When user hits the "back" button is the browser,
    // close popup but stay on the same page.
    //
    // When user hits the "forward" button in the browser,
    // advance to delivery or, if already visited, payment.

  }, {
    key: 'handleNavigation',
    value: function handleNavigation(e) {
      window.history.forward();
      e.target.closePickupLocator();
    }
  }, {
    key: 'showMore',
    value: function showMore() {
      this.setState({ showMore: true });
    }
  }, {
    key: 'renderShowMore',
    value: function renderShowMore() {
      return _react2.default.createElement(
        'div',
        { styleName: 'showMore', onClick: this.showMore.bind(this) },
        'Show more...'
      );
    }
  }]);
  return BasePickupLocator;
}(_react2.default.Component), _class.defaultProps = {
  pickupLocations: []
}, _class.maxNUmberBeforeShowMore = 10, _temp);
exports.default = BasePickupLocator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Base/index.js
// module id = 597
// module chunks = 0